import Store from 'store/store'
import { Component } from 'utils/jsx'

import Sortable from 'sortablejs'

import InputFile from 'components/dom/InputFile'
import FileDropper from 'components/dom/FileDropper'
import Button from 'components/dom/Button'

export default class Logos extends Component {
  beforeRender () {
    this.update = this.update.bind(this)
    this.handleInput = this.handleInput.bind(this)
    this.handleSort = this.handleSort.bind(this)
  }

  template () {
    return (
      <div class='logos'>
        <ul class='logos__logos' ref={this.ref('logos')} />
        <FileDropper event-change={this.handleInput} />
      </div>
    )
  }

  afterRender () {
    Store.logos.subscribe(this.update)

    this.update()
    this.sortable = Sortable.create(this.refs.logos, {
      animation: 100,
      easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
      ghostClass: 'is-ghost',
      dragClass: 'is-dragged',
      onSort: this.handleSort
    })
  }

  update () {
    this.refs.logos.innerHTML = ''

    for (const logo of Store.logos.get()) {
      this.render((
        <li class='logos__logo' data-name={logo.name}>
          <Button class='button--delete' icon='trash-o' event-click={this.handleDelete(logo).bind(this)} title='Supprimer' />
          <div class='logos__logo-infos'>{logo.name}</div>
          <img src={logo.src} title={logo.name} />
        </li>
      ), this.refs.logos)
    }

    this.render((
      <InputFile
        accept='image/*'
        multiple
        event-change={this.handleInput}
      >
        Ajouter un logo
      </InputFile>
    ), this.refs.logos)
  }

  handleInput (files) {
    Store.logos.update((logos = []) => {
      for (const file of files) {
        logos.push({
          name: file.name,
          size: file.size,
          type: file.type,
          src: URL.createObjectURL(file)
        })
      }
      return logos
    }, true)
  }

  handleSort (e) {
    const newOrder = []
    for (const el of this.refs.logos.children) {
      const name = el.getAttribute('data-name')
      const logo = name && Store.logos.current.find(logo => logo.name === name)
      if (!logo) continue
      newOrder.push(logo)
    }

    Store.logos.set(newOrder)
  }

  handleDelete ({ src }) {
    return function () {
      Store.logos.update(logos => logos.filter(logo => logo.src !== src))
    }
  }

  beforeDestroy () {
    if (this.sortable) this.sortable.destroy()
  }
}



// WEBPACK FOOTER //
// ./src/components/dom/Logos.js